import { render, staticRenderFns } from "./NewProjectDialog.vue?vue&type=template&id=6f7ab168&scoped=true&"
import script from "./NewProjectDialog.vue?vue&type=script&lang=js&"
export * from "./NewProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectDialog.vue?vue&type=style&index=0&id=6f7ab168&scoped=true&lang=scss&"
import style1 from "./NewProjectDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7ab168",
  null
  
)

export default component.exports